export default __webpack_public_path__ + "static/media/DEAD.cf382656.webp";